export default __webpack_public_path__ + "static/media/montreal-svg.fcf68c68.svg";